<script>
import baseMixin from '@/mixins/baseMixin'
import EmptyStateBlock from '@components/general/empty-state-block.vue'

export default {
  name: 'BookingPendingApprovalsListErrorBlock',
  components: { EmptyStateBlock },
  mixins: [baseMixin],
}
</script>

<template>
  <div>
    <EmptyStateBlock
      :title="$t('booking.details.loading.failure.title')"
      :description="$t('booking.details.loading.failure.description')"
      border
    >
      <template v-slot:button>
        <div class="mt-4">
          <v-btn
            data-testid="file-not-found-block-retry-btn"
            color="primary"
            class="white--text"
            depressed
            large
            @click="$emit('retry')"
          >
            <v-icon left> mdi-refresh </v-icon>
            {{ $t('general.retry') }}
          </v-btn>
        </div>
      </template>
    </EmptyStateBlock>
  </div>
</template>
